import { IAuditChange } from "../../reducers/AuditReducer";
import { IWebsocketAuditLinkUpdate, IWebsocketAuditUpdate } from "@vmosolutions/oc-interfaces";
import axios from "axios";
import { v1 } from "uuid";

export enum Type {
  ADD_AUDIT_WATCH = "ADD_AUDIT_WATCH",
  SET_AUDIT = "SET_AUDIT",
  SET_AUDIT_DATA = "SET_AUDIT_DATA",
}

export interface IAddAuditWatch {
  type: Type.ADD_AUDIT_WATCH;
  auditId: string;
}

export interface ISetAudit {
  type: Type.SET_AUDIT;
  audit: IAuditChange;
  auditId: string;
}

export interface ISetAuditData {
  type: Type.SET_AUDIT_DATA;
  audit: IAuditChange;
  auditId: string;
}

export type Action = IAddAuditWatch | ISetAudit | ISetAuditData;

export const addAuditToWatch = (auditId: string): IAddAuditWatch => {
  return { type: Type.ADD_AUDIT_WATCH, auditId };
};

export const setAuditFromLink = async (data: IWebsocketAuditLinkUpdate): Promise<ISetAudit> => {
  const auditId = data.id;

  const json = await axios.get<IWebsocketAuditUpdate>(data.url);
  const payload = json.data;

  //! New events needs some sort of identifier so the frontend can update the progress on importing them. Insert that temp id here if not provided.
  const newImportEvents = payload?.newEvents?.map((item) => {
    return !item?._id ? { ...item, _id: `temp_${v1()}` } : item;
  });

  const audit: IAuditChange = {
    startDate: payload.dateRange?.startTime,
    endDate: payload.dateRange?.endTime,
    isFinishedLoading: true,
    newEvents: newImportEvents ?? [],
    modifiedEvents: payload.modifiedEvents ?? [],
    deletedEvents: payload.deletedEvents ?? [],
  };

  return {
    type: Type.SET_AUDIT,
    audit,
    auditId,
  };
};

export const setAuditFromId = (audit: IAuditChange, auditId: string): ISetAuditData => {
  return {
    type: Type.SET_AUDIT_DATA,
    audit: audit,
    auditId,
  };
};
